export enum KYCCategoriesName {
	PSI = 'PSI',
	PSFP = 'PSFP',
	Identity = 'Identité personnelle',
	Company = 'Société',
	AdditionalQuestions = 'AdditionalQuestions',
	Simulator = 'Simulation',
	Knowledge = 'Connaissances',
	Experience = 'Expériences',
	Objectives = 'Objectifs',
	FinancialSituation = 'Situation financière',
	Finish = 'Terminé',
	Signature = 'Signature'
}
export enum KYCQuestionTypeAPI {
	CHOIX_MULTIPLE = 'CHOIX_MULTIPLE',
	CHOIX_UNIQUE = 'CHOIX_UNIQUE',
	SAISIE_TEXT = 'SAISIE_TEXT',
	SAISIE_NOMBRE = 'SAISIE_NOMBRE'
}
export enum KYCQuestionType {
	MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
	SINGLE_CHOICE = 'SINGLE_CHOICE',
	INPUT_TEXT = 'INPUT_TEXT',
	INPUT_NUMBER = 'INPUT_NUMBER',
	INPUT_TEL = 'INPUT_TEL',
	INPUT_FILE = 'INPUT_FILE',
	INPUT_SELECT = 'INPUT_SELECT',
	MULTIPLE_QUESTION = 'MULTIPLE_QUESTION',
	INTRODUCTION = 'INTRODUCTION',
	INPUT_COUNTRY = 'INPUT_COUNTRY',
	INPUT_DATE = 'INPUT_DATE',
	INPUT_CITY = 'INPUT_CITY',
	INPUT_ADDRESS = 'INPUT_ADDRESS',
	INPUT_ADDRESSPROOF = 'INPUT_ADDRESSPROOF',
	INPUT_PPE = 'INPUT_PPE',
	INPUT_HIDDEN = 'INPUT_HIDDEN',
	INPUT_LEGAL_INFORMATION_COMPANY = 'INPUT_LEGAL_INFORMATION_COMPANY',
	BENEFICIARY_STEP = 'BENEFICIARY_STEP',
	KYCSTEP = 'KYCSTEP'
}

export enum KYCStatusEnum {
	COMPLETE = 'COMPLETE',
	EXPIRED = 'EXPIRED',
	INCOMPLETE = 'INCOMPLETE'
}
